import dayjs, { Dayjs } from "dayjs";

export const auctionCodes = {
  1: "DayAhead",
  2: "SIDC_IntradayAuction1",
  3: "SIDC_IntradayAuction2",
  4: "SIDC_IntradayAuction3",
};

export const auctionIds = {
  DayAhead: 1,
  SIDC_IntradayAuction1: 2,
  SIDC_IntradayAuction2: 3,
  SIDC_IntradayAuction3: 4,
};

export const getAuctionPriceLimitBounds = (
  auctionId: number,
): { min: number; max: number } => {
  if (auctionId === auctionIds.DayAhead) {
    return { min: -600, max: 4000 };
  }
  return { min: -9999, max: 9999 };
};

export const getNPAuctionDeadlines = (date: Dayjs) => {
  return {
    DayAhead: dayjs(date).subtract(1, "days").hour(12).minute(20),
    SIDC_IntradayAuction1: dayjs(date).subtract(1, "days").hour(15).minute(20),
    SIDC_IntradayAuction2: dayjs(date).subtract(1, "days").hour(22).minute(20),
    SIDC_IntradayAuction3: dayjs(date).hour(10).minute(20),
  };
};

export const getNextNPAuction = (date: Dayjs) => {
  const auctionTimes = getNPAuctionDeadlines(date);

  for (const key of Object.keys(auctionTimes)) {
    if (dayjs().isBefore(auctionTimes[key as keyof typeof auctionTimes])) {
      return key;
    }
  }

  return null;
};

export const hasNPAuctionDeadlinePassed = (auctionId: number, date: Dayjs) => {
  const auctionTimes = getNPAuctionDeadlines(date);

  return dayjs().isAfter(
    auctionTimes[
      auctionCodes[
        auctionId as keyof typeof auctionCodes
      ] as keyof typeof auctionTimes
    ],
  );
};

export const getNPSupplyPlanDeadlines = (date: Dayjs) => {
  const auctionDeadlines = getNPAuctionDeadlines(date);
  return {
    DayAhead: auctionDeadlines.DayAhead.add(30, "minutes"),
    SIDC_IntradayAuction1: auctionDeadlines.SIDC_IntradayAuction1.add(
      30,
      "minutes",
    ),
    SIDC_IntradayAuction2: auctionDeadlines.SIDC_IntradayAuction2.add(
      30,
      "minutes",
    ),
    SIDC_IntradayAuction3: auctionDeadlines.SIDC_IntradayAuction3.add(
      30,
      "minutes",
    ),
  };
};

export const hasNPSupplyPlanDeadlinePassed = (auction: string, date: Dayjs) => {
  const supplyPlanDeadlines = getNPSupplyPlanDeadlines(date);

  return dayjs().isAfter(
    supplyPlanDeadlines[auction as keyof typeof supplyPlanDeadlines],
  );
};

export const hasNPManualSubmitWindowClosed = (auction: string, date: Dayjs) => {
  const auctionDeadlines = getNPAuctionDeadlines(date);
  const cutoff = auctionDeadlines[
    auction as keyof typeof auctionDeadlines
  ]?.add(10, "minutes");

  return cutoff ? dayjs().isAfter(cutoff) : true;
};

export const hasNPAdminSupplyPlanUploadWindowClosed = (
  auctionId: number,
  date: Dayjs,
) => {
  const auctionDeadlines = getNPAuctionDeadlines(date);
  const cutoff = auctionDeadlines[
    auctionCodes[
      auctionId as keyof typeof auctionCodes
    ] as keyof typeof auctionDeadlines
  ]?.add(40, "minutes");

  return cutoff ? dayjs().isAfter(cutoff) : true;
};
